import * as React from 'react';
import KeyFormModal from '../../regexes/key-form-modal/KeyFormModal';
import RegexFormModal from '../../regexes/regex-modal/RegexFormModal';
import AmendedContent from './AmendedContent';
const AmendedContentWrapper = ({ content = "" }) => {
    const [name, setName] = React.useState();
    const [originalRegex, setOriginalRegex] = React.useState();
    const [regex, setRegex] = React.useState();
    const [title, setTitle] = React.useState('');
    const [showKey, setShowKey] = React.useState(false);
    const [showRegex, setShowRegex] = React.useState(false);
    const [type, setType] = React.useState('keyvalues');
    return (React.createElement(React.Fragment, null,
        showKey ?
            React.createElement(KeyFormModal, { hideModal: () => setShowKey(false), name: name, title: title }) : undefined,
        showRegex ?
            React.createElement(RegexFormModal, { callback: () => document.dispatchEvent(new Event('reloadcontent')), hideModal: () => setShowRegex(false), originalRegex: originalRegex, regex: regex, title: title, type: type }) : undefined,
        React.createElement(AmendedContent, { content: content, setName: setName, setOriginalRegex: setOriginalRegex, setRegex: setRegex, setShowKey: setShowKey, setShowRegex: setShowRegex, setTitle: setTitle, setType: setType })));
};
export default AmendedContentWrapper;
